"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetLazyComponentPublic = exports.LazyComponentLoader = exports.LAZY_WIDGET_BUNDLE_FILE_NAME = void 0;
const tslib_1 = require("tslib");
const Widget_1 = require("@wix/cashier-core/dist/src/services/Widget");
const react_1 = tslib_1.__importStar(require("react"));
const ModuleRegistry_1 = require("@wix/cashier-common/dist/src/rmc-fork/ModuleRegistry");
const ReactLazyComponent_1 = require("@wix/cashier-common/dist/src/rmc-fork/ReactLazyComponent");
const mbMinified_1 = require("@wix/cashier-common/dist/src/rmc-fork/mbMinified");
const InteractionName_1 = require("../types/InteractionName");
const fedopsLogger_1 = require("../utils/fedopsLogger");
const filterDefined_1 = require("../utils/filterDefined");
const logDeprecationNote_1 = require("../utils/logDeprecationNote");
const perfNow_1 = require("../utils/perfNow");
const config_1 = require("./config");
const LazyLoadError_1 = require("./LazyLoadError");
const applyVersionOverride_1 = require("./applyVersionOverride");
exports.LAZY_WIDGET_BUNDLE_FILE_NAME = 'cashier-widget-lazy-component';
class LazyComponentLoader extends ReactLazyComponent_1.ReactLazyComponent {
    static buildFiles(props) {
        return [
            `${props.widgetSettings.widgetStaticsBaseUrl}${exports.LAZY_WIDGET_BUNDLE_FILE_NAME}.bundle${(0, mbMinified_1.mbMinified)(props.debug)}.js`,
        ];
    }
    constructor(props) {
        super(props, {
            component: config_1.LAZY_WIDGET_ID,
            files: LazyComponentLoader.buildFiles(props),
            crossorigin: true,
        });
    }
}
exports.LazyComponentLoader = LazyComponentLoader;
class WidgetLazyComponentPublic extends react_1.Component {
    constructor(props) {
        super(props);
        this._isMounted = true;
        this.onApiInitListeners = [];
        this.loadStartTime = (0, perfNow_1.perfNow)();
        this.state = {
            widgetSettings: null,
            isLazyLoadFailed: false,
        };
        this.handleApiInit = (api) => {
            if (this.props.onApiInit) {
                this.props.onApiInit(api);
            }
            // deprecated way of notifying the consumer
            this.widgetAPI = api;
            this.onApiInitListeners.forEach((listener) => listener(api));
        };
        this.onCrashSafe = (error) => {
            if (this.props.onCrash) {
                // puts callback execution in the queue, which prevents current stack execution from halting if
                // callback throws error
                setTimeout(() => {
                    this.props.onCrash(error);
                });
            }
        };
        // based on invocation https://github.com/wix/react-module-container/blob/master/src/base-lazy-component.js#L27
        this.removeLoadFailureListener = (0, ModuleRegistry_1.getModuleRegistry)().addListener('reactModuleContainer.error', (error) => {
            var _a, _b;
            // based on structure from https://github.com/wix/react-module-container/blob/master/src/ReactModuleContainerErrors.js#L39
            if ((error === null || error === void 0 ? void 0 : error.name) === 'LazyComponentLoadingError' &&
                (((_a = error.message) === null || _a === void 0 ? void 0 : _a.endsWith(config_1.LAZY_WIDGET_ID)) || ((_b = error.message) === null || _b === void 0 ? void 0 : _b.endsWith(config_1.WIDGET_ID)))) {
                console.error(`Payments Widget: Failed to load main bundle`, error);
                this.setState({ isLazyLoadFailed: true });
                this.onCrashSafe(error);
            }
        }).remove;
    }
    componentDidMount() {
        fedopsLogger_1.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.ALE);
        fedopsLogger_1.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.ALE_LAZY_MOUNT_TO_LOADER);
        fedopsLogger_1.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.LAZY_COMPONENT_LOAD);
        this.fetchWidgetSettings();
    }
    componentWillUnmount() {
        this._isMounted = false;
        if (typeof this.removeLoadFailureListener === 'function') {
            this.removeLoadFailureListener();
        }
    }
    fetchWidgetSettings() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                let widgetSettings;
                if (WidgetLazyComponentPublic.fetchWidgetSettingsPromise) {
                    // cached
                    widgetSettings = yield WidgetLazyComponentPublic.fetchWidgetSettingsPromise;
                }
                else {
                    const fetchWidgetSettingsPromise = new Widget_1.WidgetService({
                        baseURL: this.props.host,
                        appInstance: this.props.configuration.appInstance,
                        revalidateAppInstance: this.props.revalidateAppInstance,
                    }).fetchWidgetSettings((0, filterDefined_1.filterDefined)({ msid: this.props.configuration.msid }));
                    widgetSettings = yield fetchWidgetSettingsPromise;
                    // we don't want to cache during tests/in storybook/in dev env
                    if (!widgetSettings.hasOwnProperty('dev')) {
                        WidgetLazyComponentPublic.fetchWidgetSettingsPromise = fetchWidgetSettingsPromise;
                    }
                    widgetSettings = (0, applyVersionOverride_1.applyVersionOverride)(widgetSettings);
                }
                if (this._isMounted) {
                    this.setState({ widgetSettings });
                }
            }
            catch (error) {
                console.error(`Payments Widget: Failed to resolve widget settings`, error);
                this.setState({ isLazyLoadFailed: true });
                this.onCrashSafe(error);
            }
        });
    }
    getApi() {
        (0, logDeprecationNote_1.logDeprecationNote)(`"getApi" method is deprecated. Use "onApiInit" prop to retrieve Widget's API`);
        return new Promise((resolve) => {
            if (this.widgetAPI) {
                resolve(this.widgetAPI);
            }
            else {
                this.onApiInitListeners.push(resolve);
            }
        });
    }
    render() {
        const { widgetSettings, isLazyLoadFailed } = this.state;
        if (isLazyLoadFailed) {
            return react_1.default.createElement(LazyLoadError_1.LazyLoadError, { isModalTheme: this.props.theme === 'modal' });
        }
        if (widgetSettings === null) {
            return null;
        }
        return (react_1.default.createElement(LazyComponentLoader, Object.assign({}, this.props, { startLoadTime: this.loadStartTime, widgetSettings: widgetSettings, fedopsLogger: fedopsLogger_1.fedopsLogger, loadInfo: {
                loaderStartTime: this.loadStartTime,
            }, onApiInit: this.handleApiInit, onCrash: this.onCrashSafe })));
    }
}
exports.WidgetLazyComponentPublic = WidgetLazyComponentPublic;
//# sourceMappingURL=WidgetLazyComponent.public.js.map